// src/routes/statistics/report/components/AutoCsvDownloadManager.js

import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchEv_list } from '../../../../store';
import { fetchAndBuildDailyGeneration } from '../services/dailyGenerationService';
import useAutoCsvDownload from '../hooks/useAutoCsvDownload';

const AUTO_DOWNLOAD_SETTINGS_EVENT = 'autoCsvDownloadSettingsChange';

export const notifyAutoCsvDownloadSettingsChange = () => {
  window.dispatchEvent(new Event(AUTO_DOWNLOAD_SETTINGS_EVENT));
};

const readAutoDownloadSettings = () => ({
  enabled: localStorage.getItem('autoDownloadEnabled') === 'true',
  time: localStorage.getItem('autoDownloadTime') || '18:00',
});

const AutoCsvDownloadManager = () => {
  const dispatch = useDispatch();
  const ivList = useSelector((state) => state.Iv_list);
  const Ev_list = useSelector((state) => state.Ev_list || {});
  const [settings, setSettings] = useState(readAutoDownloadSettings);
  const [, setIsDownloading] = useState(false);

  useEffect(() => {
    dispatch(fetchEv_list());
  }, [dispatch]);

  useEffect(() => {
    const syncSettings = () => {
      setSettings(readAutoDownloadSettings());
    };

    const handleStorage = (event) => {
      if (
        event.key === 'autoDownloadEnabled' ||
        event.key === 'autoDownloadTime'
      ) {
        syncSettings();
      }
    };

    window.addEventListener(AUTO_DOWNLOAD_SETTINGS_EVENT, syncSettings);
    window.addEventListener('storage', handleStorage);

    return () => {
      window.removeEventListener(AUTO_DOWNLOAD_SETTINGS_EVENT, syncSettings);
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  const totalCapacity = (ivList?.iv_capa || []).reduce(
    (sum, capa) => sum + (Number(capa) || 0),
    0
  );

  const fetchAutoDownloadCsv = useCallback(
    async (date) => {
      if (!Array.isArray(ivList?.seq) || ivList.seq.length === 0) {
        throw new Error('인버터 목록이 준비되지 않았습니다.');
      }

      const { csv } = await fetchAndBuildDailyGeneration({
        start: date,
        end: date,
        mode: 'individual',
        ivList,
        Ev_list,
        totalCapacity,
      });

      return csv;
    },
    [ivList, Ev_list, totalCapacity]
  );

  useAutoCsvDownload({
    enabled: settings.enabled,
    autoDownloadTime: settings.time,
    fetchCsv: fetchAutoDownloadCsv,
    setIsDownloading,
  });

  return null;
};

export default AutoCsvDownloadManager;
